import React, { FC, useEffect } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DateInput, TextInput } from "@/components/atoms";
import { RefRadioButtonGroup, RefSelectInput } from "@/components/molecules";
import { isSubFormValid } from "@/core/form";

import { FormType } from "../../utils";

type PersonalInfoProps = {
    onComplete: () => void;
};

const PersonalInfo: FC<PersonalInfoProps> = ({ onComplete }) => {
    const { control, formState } = useFormContext<FormType>();

    const { errors, dirtyFields } = formState;

    const { t } = useTranslation();

    useEffect(() => {
        if (isSubFormValid<FormType>(dirtyFields, errors, ["language", "civilStatus", "gender", "title"])) {
            onComplete();
        }
    }, [formState]);

    return (
        <>
            <RefSelectInput name="socialStatus" control={control} table="socialStatuses" />
            <RefSelectInput name="language" control={control} required table="language" />
            <DateInput name="birthdate" control={control} disableFuture label={t("Common.BirthDate")} />
            <TextInput name="birthPlace" label={t("Common.BirthPlace")} autoComplete="off" control={control} />
            <RefSelectInput name="civilStatus" control={control} required table="maritalStatus" />
            <RefRadioButtonGroup name="gender" table="gender" control={control} required />
            <RefSelectInput name="title" control={control} table="personTitle" required />
        </>
    );
};

export default PersonalInfo;
